import { ConfirmModal } from '../components'

import type { UButton, UModal } from '#components'

type ConfirmConfig = {
  header?: string
  message?: string
  modalAttrs?: InstanceType<typeof UModal>['$props']
  acceptProps?: InstanceType<typeof UButton>['$props']
  rejectProps?: InstanceType<typeof UButton>['$props']
}

export const useConfirm = () => {
  const overlay = useOverlay()

  const require = async (config: ConfirmConfig): Promise<boolean> => {
    const modal = overlay.create(h(ConfirmModal))

    const instance = modal.open({
      header: config.header || 'Подтверждение',
      message: config.message || 'Вы уверены?',
      acceptLabel: config.acceptProps?.label || 'Подтвердить',
      rejectLabel: config.rejectProps?.label || 'Отмена',
      rejectAttrs: config.rejectProps,
      acceptAttrs: config.acceptProps,
      modalAttrs: config.modalAttrs,
    })

    const result = await instance.result

    return result === true
  }

  return {
    require,
  }
}
